import { render } from "./AgentWrapper.vue?vue&type=template&id=5d5a19fa"
import script from "./AgentWrapper.vue?vue&type=script&lang=js"
export * from "./AgentWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__